import "./newTestimonial.css";
import { MdOutlineMailOutline } from "react-icons/md";
import { RiMessengerLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { useRef, useState } from "react";
import Avatar1 from "../../assets/avatar1.jpg";
import Avatar2 from "../../assets/avatar2.jpg";
import Avatar3 from "../../assets/avatar3.jpg";
import Avatar4 from "../../assets/avatar4.jpg";
import Avatar5 from "../../assets/avatar5.jpg";
import Avatar6 from "../../assets/avatar6.jpg";
import Avatar7 from "../../assets/avatar7.png";
import Avatar8 from "../../assets/avatar8.png";
import Avatar9 from "../../assets/avatar9.png";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";
import i18n from "../../languages/i18n";

const NewTestinonial = ({ handleClose, show, onscrollHandler }) => {
  const showHideClassName = show
    ? "modalTesti display-block"
    : "modalTesti display-none";
  const form = useRef();
  const [active_avatar, setAvatar] = useState(1);
  const [sendBtnActive, setSendBtnActive] = useState(false);
  const [sending, setSending] = useState(false);
  const { t } = useTranslation();

  const sendEmail = (e) => {
    e.preventDefault();
    setSendBtnActive(true);
    setSending(true);

    emailjs
      .sendForm(
        "service_kxm3ism",
        "template_tv83men",
        form.current,
        "rdbbFpZTdJ05zizHM"
      )
      .then(
        (result) => {
          setSending(false);
          alert(
            "Thank you for your time, testimonial will be posted after review 💗"
          );

          e.target.reset();

          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div className={showHideClassName}>
      <div className="modalTesti-main ">
        <section className="new-testi-wrapper">
          <h5 className={i18n.language == "ar" && "arabicText title_h5 "}>
            {t("testiSection.support_title")}
          </h5>
          <h2 className={i18n.language == "ar" && "arabicText title_h2 "}>
            {t("testiSection.add_testi_title")}
          </h2>
          <div className="container newTesti_container">
            <div className="avatars">
              <article className="avatar_titles">
                <h4 className={i18n.language == "ar" && "arabicText"}>
                  {t("testiSection.avatar_title")}
                </h4>
                <h2 className={i18n.language == "ar" && "arabicText title_h2 "}>
                  {t("testiSection.select_avatar")}
                </h2>
              </article>
              <div className="avatar_container">
                <div
                  className={
                    active_avatar == 1 ? "selected_avatar" : "notSelectedAvatar"
                  }
                  onClick={() => setAvatar(1)}
                >
                  <div className="testi_avatar">
                    <img src={Avatar1} alt="Avatar One" srcset="" />
                  </div>
                </div>
                <div
                  className={
                    active_avatar == 2 ? "selected_avatar" : "notSelectedAvatar"
                  }
                  onClick={() => setAvatar(2)}
                >
                  <div className="testi_avatar">
                    <img src={Avatar2} alt="Avatar 4" srcset="" />
                  </div>
                </div>
                <div
                  className={
                    active_avatar == 3 ? "selected_avatar" : "notSelectedAvatar"
                  }
                  onClick={() => setAvatar(3)}
                >
                  <div className="testi_avatar">
                    <img src={Avatar3} alt="Avatar 3" srcset="" />
                  </div>
                </div>
                <div
                  className={
                    active_avatar == 4 ? "selected_avatar" : "notSelectedAvatar"
                  }
                  onClick={() => setAvatar(4)}
                >
                  <div className="testi_avatar">
                    <img src={Avatar4} alt="Avatar 4" srcset="" />
                  </div>
                </div>
                <div
                  className={
                    active_avatar == 5 ? "selected_avatar" : "notSelectedAvatar"
                  }
                  onClick={() => setAvatar(5)}
                >
                  <div className="testi_avatar">
                    <img src={Avatar5} alt="Avatar 5" srcset="" />
                  </div>
                </div>
                <div
                  className={
                    active_avatar == 6 ? "selected_avatar" : "notSelectedAvatar"
                  }
                  onClick={() => setAvatar(6)}
                >
                  <div className="testi_avatar">
                    <img src={Avatar6} alt="Avatar 6" srcset="" />
                  </div>
                </div>
                <div
                  className={
                    active_avatar == 7 ? "selected_avatar" : "notSelectedAvatar"
                  }
                  onClick={() => setAvatar(7)}
                >
                  <div className="testi_avatar">
                    <img src={Avatar7} alt="Avatar 6" srcset="" />
                  </div>
                </div>
                <div
                  className={
                    active_avatar == 8 ? "selected_avatar" : "notSelectedAvatar"
                  }
                  onClick={() => setAvatar(8)}
                >
                  <div className="testi_avatar">
                    <img src={Avatar8} alt="Avatar 6" srcset="" />
                  </div>
                </div>
                <div
                  className={
                    active_avatar == 9 ? "selected_avatar" : "notSelectedAvatar"
                  }
                  onClick={() => setAvatar(9)}
                >
                  <div className="testi_avatar">
                    <img src={Avatar9} alt="Avatar 6" srcset="" />
                  </div>
                </div>
              </div>
            </div>

            <form ref={form} onSubmit={sendEmail} className="testimonial-form">
              <input
                type="number"
                name="avatar"
                required
                value={active_avatar}
                id="hidden_input"
              />
              <input
                type="text"
                name="name"
                placeholder={t("testiSection.youName_title")}
                className={i18n.language == "ar" && "arabicText rtlText"}
                required
              />
              <input
                type="text"
                name="company"
                placeholder={t("testiSection.yourCompany_Title")}
                className={i18n.language == "ar" && "arabicText rtlText"}
                required
              />
              <input
                type="email"
                name="email"
                placeholder={t("testiSection.youMail_title")}
                required
                className={i18n.language == "ar" && "arabicText rtlText"}
              />
              <textarea
                name="message"
                rows="7"
                placeholder={t("testiSection.message_title")}
                required
                className={i18n.language == "ar" && "arabicText rtlText"}
              ></textarea>
              <div className="actionButtons">
                <button
                  type="submit"
                  className="btn btn-primary arabicText"
                  disabled={sendBtnActive}
                >
                  {!sending ? t("btn_send_title") : t("btn_sending_title")}
                </button>
                <button
                  type="submit"
                  className="btn btn-primary arbicText"
                  onClick={handleClose}
                >
                  {t("btn_cancel_title")}
                </button>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NewTestinonial;
